import { TrajectoryFunctionType } from './trajectory-function-type';

export function getWeightCurve(
  weight: number,
  length: number,
  type: TrajectoryFunctionType,
  originValue: number = 0,
  isAbsoluteWeight: boolean = false
): number[] | undefined {
  if (type === TrajectoryFunctionType.LINEAR) {
    return getLinearCurve(weight, length, originValue, isAbsoluteWeight);
  } else if (type === TrajectoryFunctionType.EXPONENTIAL) {
    return getExponentialCurve(weight, length, originValue, isAbsoluteWeight);
  }
}

function getLinearCurve(weight: number, length: number, originValue: number, isAbsoluteWeight: boolean): number[] {
  const weightSeries = [];
  const step = weight / (length - 1);
  const absoluteStep = (weight - originValue) / (length - 1);
  for (let i = 0; i < length; i++) {
    if (isAbsoluteWeight) {
      weightSeries.push(originValue + absoluteStep * i);
    } else {
      weightSeries.push(Math.min(1, step * i));
    }
  }
  return weightSeries;
}

function getExponentialCurve(weight: number, length: number, originValue: number, isAbsoluteWeight: boolean): number[] {
  // @TODO: consider absolute weights
  const weightSeries = [];
  const base = Math.pow(weight + 1, 1 / (length - 1));
  for (let exponent = 0; exponent < length; exponent++) {
    const val = Math.pow(base, exponent);
    if (isAbsoluteWeight) {
      weightSeries.push(val - 1);
    } else {
      weightSeries.push(Math.min(1, val - 1));
    }
  }
  return weightSeries;
}
